export enum ProjectSortingProperties {
    COMPANY_NAME = 'companyName',
    LABEL = 'label',
    BALANCE_SHEET_DATE = 'balanceSheetDate',
    ASSIGNEE = 'assignee',
    REPORT_TYPE = 'reportType',
    STATUS = 'projectStatus',
}
